<template>
  <div class="singleSet">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">工单标签设置</span>
        <div class="head-text">
          <el-button type="primary" @click="addSingle1 = true">新增</el-button>
          <el-button type="danger" @click="batchRemove">删除</el-button>
        </div>
      </div>
      <!-- 表格 -->
      <div class="rygl-table">
        <el-table
          align="center"
          class="margin-20 table width100"
          v-loading="loading"
          :data="singleList"
          height="72vh"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            align="center"
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="wost02"
            label="名称"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="wost03"
            label="排序"
          ></el-table-column>
          <el-table-column align="center" prop="wost04" label="底纹颜色">
            <template slot-scope="scope">
              <el-color-picker
                @change="yss(scope.row)"
                v-model="scope.row.wost04"
              ></el-color-picker>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="wost05" label="文字颜色">
            <template slot-scope="scope">
              <el-color-picker
                @change="yss(scope.row)"
                v-model="scope.row.wost05"
              ></el-color-picker>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="user02"
            label="维护人员"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="wost07"
            label="更新时间"
          ></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                plain
                @click="editor(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="danger"
                plain
                @click="deleteSingle(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination
        align="center"
        class="mar-top20"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[100, 50, 10]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <!-- 新增工单标签 -->
      <el-dialog
        :close-on-click-modal="false"
        title="新增工单标签"
        :visible.sync="addSingle1"
      >
        <el-form ref="form" :model="addPostList" label-width="80px">
          <!-- <el-form-item label="名称">
            <el-input v-model="addPostList.user02"></el-input>
          </el-form-item>
          <el-form-item label="排序">
            <el-input v-model="addPostList.user01"></el-input>
          </el-form-item>-->
          <el-form-item label="名称">
            <el-input v-model="addPostList.wost02"></el-input>
          </el-form-item>
          <!-- <el-form-item label="维护人员">
            <el-input v-model="addPostList.user02"></el-input>
          </el-form-item>-->
          <el-form-item label="排序">
            <el-input
              type="number"
              v-model.number="addPostList.wost03"
            ></el-input>
          </el-form-item>
          <el-form-item label="系统时间">
            <el-date-picker
              v-model="addPostList.wost07"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-row>
            <el-col :span="4">
              <el-form-item label="底纹颜色">
                <el-color-picker v-model="addPostList.wost04"></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文字颜色">
                <el-color-picker v-model="addPostList.wost05"></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3" :offset="10">
              <el-button type="primary" @click="addform">确定</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="danger" @click="addSingle1 = false"
                >取消</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog
        :close-on-click-modal="false"
        title="编辑工单标签"
        :visible.sync="editor1"
      >
        <el-form ref="form" :model="editorPostList" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="editorPostList.wost02"></el-input>
          </el-form-item>
          <!-- <el-form-item label="维护人员">
            <el-input v-model="editorPostList.user02"></el-input>
          </el-form-item>-->
          <el-form-item label="排序">
            <el-input v-model="editorPostList.wost03"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="底纹颜色">
                <el-color-picker
                  v-model="editorPostList.wost04"
                ></el-color-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文字颜色">
                <el-color-picker
                  v-model="editorPostList.wost05"
                ></el-color-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="更新时间">
            <el-date-picker
              v-model="editorPostList.wost07"
              type="datetime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-row>
            <el-col :span="3" :offset="10">
              <el-button type="primary" @click="Update">确定</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="danger" @click="editor1 = false">取消</el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { GetLabel, RemoveLabel, UpdateLabel, AddLabel } from "@/setAxios.js";
export default {
  name: "singleSet",
  data() {
    return {
      loading: false,
      addSingle1: false,
      editor1: false,
      editorPost1: false,
      total: 0,
      searchword: "",
      pagesize: 10,
      pagenum: 1,
      editorPostList: {},
      addPostList: {
        wost02: "",
        wost03: "",
        wost04: "",
        wost05: "",
        wost07: "",
        wost08: null,
        wost06: null,
      },
      singleList: [],
      multipleSelection: [],
    };
  },
  methods: {
    yss(i) {
      //("颜色改变了", i);
      this.loading = true;
      let params = JSON.stringify(i);
      UpdateLabel({ workorder: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "修改颜色成功",
          });
          this.getData();
          this.loading = false;
        }
      });
    },
    //   这里是删除单个工单
    deleteSingle(row) {
      //(row);
      this.loading = true;
      let params = JSON.stringify(row.wost01);
      RemoveLabel({ id: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "删除成功:" + row.wost02,
          });
        }
        this.getData();
        this.loading = false;
      });
    },
    // 添加工单
    addSingle() {},
    // 编辑工单
    editor(row) {
      this.editor1 = true;
      this.editorPostList = row;
      //(row);
    },
    // 编辑确定按钮
    Update() {
      this.loading = true;
      let params = JSON.stringify(this.editorPostList);
      UpdateLabel({ workorder: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "编辑成功",
          });
          this.getData();
          this.editor1 = false;
          this.loading = false;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    // 获取所有数据
    getData() {
      this.loading = true;
      let params = {
        id: localStorage.getItem("xid"),
        searchword: this.searchword,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      GetLabel({ params }).then((res) => {
        //(res);
        this.total = res.Data.total;
        this.singleList = res.Data.list;
        // this.singleList.map((i, index) => {
        //   i.wost07 = new Date(
        //     parseInt(i.wost07.substr(6, 13))
        //   ).toLocaleDateString();
        // });
        this.loading = false;
      });
    },
    // 新增确定按钮
    addform() {
      this.addPostList.wost08 = localStorage.getItem("xid");
      this.addPostList.wost03 = this.addPostList.wost03;
      this.addPostList.wost06 = localStorage.getItem("id");
      // this.addPostList.wost01=parseInt(localStorage.getItem('xid'))
      let params = JSON.stringify(this.addPostList);
      //(params);

      // debugger;
      AddLabel({ workorder: params }).then((res) => {
        //(res);
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "新增成功",
          });
          this.getData();
          this.addSingle1 = false;
        }
      });
    },
    // 批量删除
    batchRemove() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将删除所选工单标签！ 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.multipleSelection.forEach((i, index) => {
              //(i);
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          message: "没有选择要删除的目标",
          type: "warning",
        });
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 20px;
}
</style>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.width100 {
  width: 100%;
}
.mar-top20 {
  margin-top: 20px;
}
</style>
